export default __webpack_public_path__ + "static/media/multi-language.91a2557f.png";